import styled from 'styled-components';

export const LabeledFieldContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    &.full-width {
        width: 100%;
    }
`;
